import React from "react";
import PropTypes from "prop-types";
import { useSelector } from "react-redux";
import {
  SANDBOX_ACCESS,
  getSandboxFeatureAccess,
} from "helpers/sandboxAccess";
import { selectIsSandboxEnvironment } from "../../redux/selectors";
import SandboxAccessDenied from "./SandboxAccessDenied";

export default function SandboxAccessGate({ feature, children }) {
  const isSandbox = useSelector(selectIsSandboxEnvironment);
  const access = getSandboxFeatureAccess(feature, isSandbox);

  if (access === SANDBOX_ACCESS.DISABLED || access === SANDBOX_ACCESS.HIDDEN) {
    return <SandboxAccessDenied hidden={access === SANDBOX_ACCESS.HIDDEN} />;
  }

  return children;
}

SandboxAccessGate.propTypes = {
  feature: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
